/*
 * (c) Copyright Reserved EVRYTHNG Limited 2022. All rights reserved.
 * Use of this material is subject to license.
 * Copying and unauthorised use of this material strictly prohibited.
 */

/**
 * Exchange Operator's API key for Shield access token.
 *
 * @param {string} apiUrl - Current EVRYTHNG API URL.
 * @param {string} apiKey - Operator API Key or Access Token with shieldAuth permission.
 * @returns {string} Shield access token.
 */
export const getShieldAccessToken = async (apiUrl, apiKey) => {
  const queryParams = new URLSearchParams({
    scopes: 'watermark:detect',
    provider: 'illuminate',
  });

  const response = await fetch(
    `${apiUrl}/shield/accessToken?${queryParams.toString()}`,
    {
      headers: { Authorization: apiKey },
    },
  );

  if (!response.ok) {
    throw new Error(
      `Shield access token request failed with status ${response.status}`,
    );
  }

  const { access_token: accessToken } = await response.json();
  if (!accessToken) {
    throw new Error('Shield access token response missing access_token');
  }

  return accessToken;
};
